const wrapper = document.querySelector('.has-cities') as HTMLDivElement;
const formName = (wrapper?.querySelector('form') as HTMLFormElement)?.name;

const selectedValue = wrapper?.getAttribute('data-selectedValue')

const zipCodeInput = document.getElementById(formName + '_zipcode') as HTMLInputElement;
const citySelector = document.getElementById(formName + '_ajax_city') as HTMLSelectElement;
const otherCity = document.getElementById('otherCity') as HTMLElement;
const otherCityLabel = otherCity?.querySelector('[for="' + formName + '_otherCity"]') as HTMLLabelElement;
const otherCityInput = otherCity?.querySelector('[id="' + formName + '_otherCity"]') as HTMLInputElement;

export const signup_init = () => {


    if (!wrapper || !formName) return

    const zipCodeStrictPattern = new RegExp('^[0-9]{5}$');
    const zipCodePattern = new RegExp('^[0-9]{3,5}$');

    if (zipCodeStrictPattern.test(zipCodeInput.value) && (citySelector.value != '' || citySelector.value != null)) {
        const citySelected = citySelector.selectedIndex;
        populateCitiesDropDown(zipCodeInput.value, citySelected, selectedValue);
    }

    zipCodeInput.addEventListener('keyup', () => {
        citySelector.innerHTML = '<option value="" selected="selected">Choisissez votre ville</option>';
        if (zipCodePattern.test(zipCodeInput.value)) {
            populateCitiesDropDown(zipCodeInput.value, 0);
        }
    }, false);


    citySelector.addEventListener('change', () => {
        if (Number(citySelector.value) == 0) {
            otherCityInput.setAttribute('required', 'required');
            otherCityLabel.classList.add('required');
            otherCity.classList.remove('hidden');
        } else {
            otherCityInput.removeAttribute('required');
            otherCityLabel.classList.remove('required');
            otherCity.classList.add('hidden');
        }
    }, false);

}


const populateCitiesDropDown = (zipCode: string, selectedIndex: number, cityId: null | string = null) => {
    const xhr = new XMLHttpRequest();
    const loader = document.getElementById('loading-cities');
    const getCitiesUrl = wrapper?.getAttribute('data-cityUrl')

    xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        otherCityInput.removeAttribute('required');
        otherCityInput.value = ""
        otherCityLabel.classList.remove('required');
        otherCity.classList.add('is-hidden');
        if (xhr.status >= 200 && xhr.status < 300) {
            const response = JSON.parse(xhr.response);

            citySelector.options.length = 1;
            for (let i = 0, l = response.cities.length; i < l; i++) {
                const node = response.cities[i];
                citySelector.options[i + 1] = new Option(node.normalizedName, node.id, false, false);
            }
            citySelector.options[citySelector.options.length] = new Option('Autre...', String(0), false, false);
            citySelector.options.selectedIndex = selectedIndex;

            if (cityId != null) {
                for (let i = 0; i < citySelector.options.length; i++) {
                    if (citySelector.options[i].value == selectedValue) {
                        citySelector.options.selectedIndex = i;
                        break;
                    }
                }
            }

        }

        setTimeout(() => {
            loader?.classList.add('is-hidden');
        }, 1000);
    };
    xhr.open('GET', getCitiesUrl + '?zipCode=' + zipCode);
    xhr.send();
}
